import React from 'react';
import { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { loadPublicContent } from '../utils/siteContent';
import './SalaryListPage.css';

export function SalaryListPage() {
  const navigate = useNavigate();
  const [salaryItems, setSalaryItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    loadPublicContent('salaries').then((items) => {
      if (isActive) {
        setSalaryItems(items);
        setIsLoading(false);
      }
    });
    return () => { isActive = false; };
  }, []);

  return (
    <main className="salary-page-shell">
      <header className="salary-page-header">
        <button className="salary-back-button" type="button" aria-label="হোম পেইজে ফিরে যান" onClick={() => navigate('/')}>
          <ArrowLeft size={22} />
        </button>
        <img src="/logo.png" alt="Earneeds logo" />
        <span>Earneeds</span>
      </header>

      <section className="salary-page-main">
        <div className="salary-page-title">
          <p>Earneeds community</p>
          <h1>সেলারি লিস্ট</h1>
        </div>

        {isLoading ? (
          <p className="salary-empty-state">লোড হচ্ছে...</p>
        ) : salaryItems.length === 0 ? (
          <p className="salary-empty-state">এখনো কোনো সেলারি তথ্য যোগ করা হয়নি।</p>
        ) : <div className="salary-table-wrap">
          <table className="salary-table">
            <thead>
              <tr>
                <th scope="col">কাজ</th>
                <th scope="col">হিসাব</th>
                <th scope="col">পারিশ্রমিক</th>
              </tr>
            </thead>
            <tbody>
              {salaryItems.map((item) => (
                <tr key={item.task}>
                  <th scope="row">{item.task}</th>
                  <td>{item.unit}</td>
                  <td className="salary-amount">{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>}
      </section>
    </main>
  );
}